<template>
	<div class="orderDetail">
		<section class="orderDetail-top">
			<div class="orderDetail-top-t">
				<span>{{statusTitle}}</span>
				<span v-if="list.status == 1" @click="delOrder">取消订单</span>
				<span v-if="list.status != 1"
					@click="$router.push({ path: '/orderList',query:{'orderType':orderType}})">返回我的订单列表</span>
			</div>
			<div class="orderDetail-top-c">
				<font v-if="list.status == 1">客服确认，请您在两小时内付款，预期订单会被关闭。<br />如有疑问可联系客服。</font>
				<font v-if="list.status == 16">抱歉，由于您长时间未付款或客服审核不通过原因，<br />该订单已作废。如有疑问，请联系客服。</font>
				<font v-if="list.status == 12">您的预定已完成<br />甜程旅行网祝您旅途愉快。</font>
				<font v-if="list.status == 8">您已支付成功!请耐心等待，<br />客服小姐姐正在为您出单！</font>
				<font v-if="list.status == 6">此产品需要二次确认,您的甜程专属客服即将与你联系,<br />请保持电话畅通。</font>
			</div>

			<div class="orderDetail-top-b" v-if="list.xqsnGroupImageUrl && orderType == 8">
				<img class="img-bac" :src="'https://sweetour-pic.obs.myhwclouds.com/pic_lsq.png?v='+Math.random()"
					alt="">
				<img class="img-erm" :src="list.xqsnGroupImageUrl+'?v='+Math.random()" alt="">
			</div>
			<div class="orderDetail-top-b" v-else>
				<img :src="'https://jiaqi.obs.cn-north-1.myhuaweicloud.com/sweetourmini/ewm.png?v='+Math.random()"
					alt="">
			</div>
		</section>
		<!-- 产品信息 -->
		<section class="orderDetail-center">
			<div class="orderDetail-center-t">
				<h2 class="orderDetail-title">产品信息</h2>
				<span class="sub-part-head">
					<p>{{list.productName}}</p>
					<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-anew-image_right.png" alt="">
				</span>
				<span class="sub-part-item">
					<p class="item-left">订单号</p>
					<p class="color">{{list.orderNo}}</p>
				</span>
				<span class="sub-part-item">
					<p class="item-left">创建时间</p>
					<p class="color">{{list.addDate}}</p>
				</span>
				<span class="sub-part-item">
					<p class="item-left">套餐类型</p>
					<p class="color">{{list.skuName}}</p>
				</span>
				<span class="sub-part-item">
					<p class="item-left">出行日期</p>
					<p class="color">{{list.useDate}}</p>
				</span>
				<span class="sub-part-item">
					<p class="item-left">购买数量</p>
					<p class="color">{{list.buyNum}}</p>
				</span>
				<span class="sub-part-item">
					<p class="item-left">订单金额</p>
					<p class="color">{{list.originalPrice}}</p>
				</span>
				<span class="sub-part-item">
					<p class="item-left">实付金额</p>
					<p class="color">{{list.actualPrice}}</p>
				</span>
				<span class="sub-part-item" v-if="coupon_money > 0">
					<p class="item-left">优惠</p>
					<p class="color">-￥{{coupon_money}}</p>
				</span>
				<span class="sub-part-item" v-if="list.checkNo">
					<p class="item-left">核销信息</p>
					<p class="color" style="color:#ff6d00" @click="show = true,hexiaoshow=true">查看</p>
				</span>
			</div>
			<div class="orderDetail-center-c">
				<h2 class="orderDetail-title">出行人信息</h2>
				<ul>
					<li v-for="(item,index) in travelerList">
						<p v-for="(map,sort) in item.items" :key="sort" v-if="map.isMain">{{map.tagValue}}</p>
					</li>
				</ul>
			</div>
			<div class="orderDetail-center-c">
				<h2 class="orderDetail-title">联系人信息</h2>
				<span class="sub-part-item">
					<p class="item-left">姓名</p>
					<p class="color">{{list.attnName}}</p>
				</span>
				<span class="sub-part-item">
					<p class="item-left">电话</p>
					<p class="color">{{list.attnPhone}}</p>
				</span>
			</div>
		</section>
		<!-- 备注 -->
		<section class="orderDetail-bottom">
			<h2 class="orderDetail-title">备注</h2>
			<span>{{list.customerNotes}}</span>
		</section>
		<!-- 支付 -->
		<section class="orderDetail-pay" v-if="list.status == 1">
			<span>
				<p>价格：</p>￥{{list.actualPrice}}
			</span>
			<span @click="pay">支付</span>
		</section>
		<van-popup v-model="show" round :class="zhifushow?'orderDetail-popup1':'orderDetail-popup'">
			<template v-if="hexiaoshow">
				<div class="van-popup-title">
					<span>核销码:{{list.checkNo}}</span>
					<img @click="getInfo(),show = false,hexiaoshow= false"
						src="https://sweetour-pic.obs.myhwclouds.com/wyq-close.png" alt="">
				</div>
				<div class="van-popup-img">
					<img :src="list.checkPIcUrl" alt="">
				</div>
			</template>
			<template v-if="zhifushow">
				<div class="van-popup-title1">
					<span>请确认微信支付是否完成</span>
				</div>
				<div class="van-popup-img1">
					<label for="" style="color: #ff6d00;" @click="okPay">已完成支付</label>
					<label for="" @click="show = false,zhifushow= false">支付遇到问题，重新支付</label>
				</div>
			</template>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		Toast
	} from 'vant';
	import {
		_throttle
	} from '@/config/util'
	import * as jweixin from 'weixin-js-sdk'
	export default {
		name: 'orderDetail',
		components: {

		},
		data() {
			return {
				list: [],
				travelerList: [],
				coupon_money: 0,
				show: false,
				hexiaoshow: false,
				zhifushow: false,
				statusTitle: ''
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {
			this.orderType = this.$route.query.orderType
			window.JSToNative = this.getDataFromNative
		},
		mounted() {
			this.getInfo()
			// if (this.$route.query.payTrue) {
			// 	this.getQueryOrder()
			// }
		},
		methods: {
			getDataFromNative() {
				this.getInfo()
			},
			okPay() {
				this.$post(
					this.$login + '/LST/QueryOrder', {
						"cust_OrderNO": this.list.orderNo
					}
				).then(res => {
					// console.log(res)
					if (res == 2) {
						this.show = false
						this.zhifushow = false
						this.getInfo()
					} else if (res == 3) {
						this.show = false
						this.zhifushow = false
						Toast("支付失败")
					} else if (res == 6) {
						this.show = false
						this.zhifushow = false
						this.getInfo()
						Toast("订单已取消")
					} else if (res == 1) {
						Toast("支付中，请重新点击完成")
					} else {
						this.show = false
						this.zhifushow = false
					}
				})
			},
			okPays() {
				this.$post(
					this.$login + '/LST/QueryOrder', {
						"cust_OrderNO": this.list.orderNo
					}
				).then(res => {
					// console.log(res)
					if (res == 6) {
						this.getInfo()
					}
				})
			},
			pay: _throttle(function() {
				const toast = Toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: '支付中',
				});
				this.$post(
					this.$login + '/LST/QueryOrder', {
						"cust_OrderNO": this.list.orderNo
					}
				).then(result => {
					if (result == 2) {
						Toast.clear();
						Toast('您已支付，无需重新提交~~');
					} else {
						var data = {
							"orderId": Number(this.$route.query.orderId),
							"openId": this.userInfo.openid
						}
						this.$_postNew(
							this.$apiNearTravel + "/api/services/app/Order/TCPayAsync", data
						).then(res => {
							Toast.clear();
							console.log(res.result)
							this.wxPay(res.result.data)
						})
					}

				})

			}, 3000),
			// 凋起支付
			wxPay(e) {
				var _this = this
				jweixin.config({
					debug: false, // 关闭调试
					appId: e.appId,
					timestamp: e.timeStamp,
					nonceStr: e.nonceStr,
					signature: e.paySign,
					jsApiList: [
						'chooseWXPay'
					]
				});
				jweixin.ready(function() {
					jweixin.chooseWXPay({
						timestamp: e.timestamp,
						nonceStr: e.nonceStr,
						package: e.package,
						paySign: e.paySign,
						signType: e.signType,
						success: res => {
							_this.getInfo()
						},
						cencel: res => {
							Toast('取消支付');
						},
						fail: err => {
							Toast('支付失败');
						}
					});
				})

			},
			// 文档方法
			loadURL(url) {
				var iFrame;
				iFrame = document.createElement("iframe");
				iFrame.setAttribute("src", url);
				iFrame.setAttribute("style", "display:none;");
				iFrame.setAttribute("height", "0px");
				iFrame.setAttribute("width", "0px");
				iFrame.setAttribute("frameborder", "0");
				document.body.appendChild(iFrame);
				iFrame.parentNoderemoveChild(iFrame);
				iFrame = null;
			},

			delOrder() {
				this.$_postNew(
					this.$severOrder + '/NTOrders/Post_CancelNTOrder', {
						'orderId': this.$route.query.orderId,
						"userId": this.userInfo.userId
					}
				).then(res => {
					this.connectCancelCoupon();
				})
			},
			connectCancelCoupon() {
				this.$post(
					this.$activity + '/Coupon/APPUserCancelUseCoupon', {
						"orderId": Number(this.$route.query.orderId),
						"productType": "NearTravel"
					}
				).then(res => {
					const toast = Toast.loading({
						duration: 0, // 持续展示 toast
						forbidClick: true,
						message: '正在取消订单',
					});

					let second = 2;
					const timer = setInterval(() => {
						second--;
						if (second) {
							toast.message = '正在取消订单';
						} else {
							clearInterval(timer);
							// 手动清除 Toast
							Toast.clear();
							this.$router.back()
						}
					}, 1000);
				})
			},
			getInfo() {
				this.$_postNew(
					this.$severOrder + '/NTOrders/Post_GetNTOrderInfoAsync', {
						'id': this.$route.query.orderId
					}
				).then(res => {
					this.list = res.result
					this.travelerList = res.result.newTravelers
					this.statusTitle = this.getStatus(res.result.status)
					this.getCouponMoney()
					if (res.result.status == 1) {
						this.okPays()
					}
				})
			},
			getCouponMoney() {
				this.$get(
					this.$activity + '/Coupon/GetCouponInfoByOrderId?orderId=' + this.$route.query.orderId, {}
				).then(res => {
					this.coupon_money = Number(res.data.money)
				})
			},
			// 状态
			getStatus(e) {
				if (e == 1) {
					return '待支付'
				}

				if (e == 2) {
					return '待出行'
				}

				if (e == 6) {
					return '等待客服审核'
				}

				if (e == 8) {
					return '待出单'
				}

				if (e == 5) {
					return '已取消'
				}

				if (e == 11) {
					return '待评价'
				}

				if (e == 12) {
					return '已完成'
				}

				if (e == 16) {
					return '已作废'
				}
			},
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f6f6f6')
		}
	}
</script>

<style>
	.orderDetail {
		padding-bottom: 160px;
	}

	.orderDetail-top {
		width: 100%;
		height: 528px;
		background: linear-gradient(to bottom, #ff6d00 0%, #f4f4f4 100%);
		display: flex;
		flex-direction: column;
	}

	.orderDetail-top-t {
		padding: 60px 50px 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		color: #fff;

	}

	.orderDetail-top-t span:first-child {
		font-size: 42px;
		font-weight: bold;
	}

	.orderDetail-top-t span:last-child {
		font-size: 28px;
		opacity: .6;
	}

	.orderDetail-top-c {
		padding: 0 50px;
		box-sizing: border-box;
		margin: 44px 0;
		font-size: 26px;
		color: #fff;
		line-height: 38px;
	}

	.orderDetail-top-b {
		margin-top: auto;
		padding: 0 20px;
		box-sizing: border-box;
		position: relative;
	}

	.orderDetail-top-b img {
		width: 100%;
	}

	.orderDetail-center,
	.orderDetail-bottom {
		width: 710px;
		padding: 36px 30px;
		box-sizing: border-box;
		border-radius: 24px;
		background-color: #fff;
		margin: auto;
		margin-top: 20px;
	}

	.orderDetail-title {
		font-size: 30px;
		color: #333;
	}

	.sub-part-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 30px;
		margin-bottom: 40px;
		font-size: 28px;
		color: #333;
	}

	.sub-part-head img {
		width: 12px;
	}

	.sub-part-item {
		display: flex;
		align-items: center;
		margin-top: 20px;
		font-size: 28px;
		color: #999;
	}

	.item-left {
		width: 200px;
	}

	.color {
		flex: 1;
		color: #333;
	}

	.orderDetail-center-c {
		width: 100%;
		border-top: 1px solid #f5f5f5;
		margin-top: 40px;
		padding-top: 30px;
	}

	.orderDetail-center-c ul li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 20px;
		font-size: 28px;
		color: #333;
	}

	.orderDetail-center-c ul li font {
		color: #999;
		width: 120px;
	}

	.orderDetail-center-c ul li p {
		flex: 1;
	}

	.orderDetail-bottom span {
		width: 100%;
		height: 160px;
		font-size: 28px;
		color: #ccc;
		display: block;
		padding-top: 20px;
	}

	.orderDetail-pay {
		width: 100%;
		background-color: #fff;
		position: fixed;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 96px;
	}

	.orderDetail-pay span {
		height: 96px;
		display: flex;
		align-items: center;
	}

	.orderDetail-pay span:first-child {
		flex: 1;
		font-size: 38px;
		color: #ff6d00;
		padding-left: 30px;
		border-top: 1px solid #e5e4e3;
		box-sizing: border-box;
	}

	.orderDetail-pay span:first-child p {
		font-size: 28px;
		color: #333;
	}

	.orderDetail-pay span:last-child {
		justify-content: center;
		background: #ff6d00;
		font-size: 36px;
		text-align: center;
		color: #fff;
		width: 286px;
	}

	.orderDetail-popup {
		width: 600px;
		padding: 10px 20px 60px 20px;
		box-sizing: border-box;
	}

	.orderDetail-popup1 {
		width: 600px;
	}

	.van-popup-title {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 30px;
		color: #333;
		font-weight: Bold;
	}

	.van-popup-title img {
		width: 84px;
		height: 84px;
	}

	.van-popup-img {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	.van-popup-img img {
		margin-top: 40px;
		width: 480px;
		height: 480px;
	}

	.orderDetail-top-b .img-bac {
		width: 712px;
		height: 240px;
	}

	.orderDetail-top-b .img-erm {
		width: 209px;
		height: 209px;
		position: absolute;
		top: 16px;
		right: 22px;
	}

	.van-popup-title1 {
		text-align: center;
		height: 88px;
		align-items: center;
		justify-content: center;
		display: flex;
	}

	.van-popup-img1 {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #999;
	}

	.van-popup-img1 label {
		width: 100%;
		border-top: 1px solid #e5e4e3;
		height: 88px;
		align-items: center;
		justify-content: center;
		display: flex;
	}
</style>